<div class="card">
    <img src="/assets/images/bds_illustration.jpg" alt="Avatar" style="width:100%">
    <div class="container text-center mt-5">
      <h4><b>Uh  oh, that page couldn't be found.</b></h4>
      <p>Please check for any errors in the page address you typed in. </p>
    </div>
  </div> 
